export default __webpack_public_path__ + "static/media/vote.1aa70861.gif";